import React from 'react'
import SVG from 'react-inlinesvg'
import { HeaderContainer, HeaderHelp } from '../shared/elements'
import { logoutPath } from '../../utils/paths'

export default function Header(props) {
  return (
    <header>
      <HeaderContainer>
        <div className="logo">
          <img
            src="/images/logo.png"
            srcSet="/images/logo.png 1x, /images/logo@2x.png 2x"
            height={25}
          />
        </div>
        <div className="control">
          <HeaderHelp />

          <a href={logoutPath()} className="control-menu logout">
            <span>Logout</span>
          </a>
        </div>
      </HeaderContainer>
    </header>
  )
}
